
export class LoginFailureEvent {
	constructor(public helpMessages: string[]) {
	}
}
